import React from "react";

/**
 * Isolates a panel so a render failure inside it cannot unmount the page.
 *
 * Added after a stale data file (an older export where `trades` was a count
 * rather than a list) threw inside IdeasPanel and blanked the entire symbol
 * page. A data panel failing should cost that panel, not the whole route.
 *
 * Renders nothing on failure in production — the rest of the page is the
 * valuable part — and surfaces the error on localhost where it is actionable.
 */
export default class PanelErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[${this.props.name || "panel"}] render failed:`, error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    const isDev = typeof window !== "undefined" &&
      (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
    if (!isDev) return null;

    return (
      <div style={{
        border: "1px dashed #dc2626", borderRadius: 8, padding: "12px 14px",
        background: "#fef2f2", color: "#991b1b", fontSize: 12, lineHeight: 1.6,
      }}>
        <strong>{this.props.name || "Panel"} failed to render.</strong>{" "}
        {String(this.state.error?.message || this.state.error)}
        <div style={{ color: "#b91c1c", marginTop: 4 }}>
          Shown on localhost only. The rest of the page is unaffected.
        </div>
      </div>
    );
  }
}
